import miniGameStyles from '../../../../public/assets/css/mini-game-styles.css?inline';

export const renderMiniGameRootUI = () => {
  const styleElement = document.createElement('style');
  styleElement.appendChild(document.createTextNode(miniGameStyles));

  document.head.appendChild(styleElement);
  return `<div id="mini-game-root">
    <div id="mini-game-spinner" class="loader__icon" style="box-sizing:unset">
    </div>
    <div id="mini-game-frame">
    </div>
    </div>`;
};
